// extracted by mini-css-extract-plugin
export var editor = "_1v-0";
export var flowSidebar = "_4j-2";